import { IModalDialogHandler } from "../../../../dialog/dialog.service.interface";
import {RealityCheckDialogPresenterBase} from "../reality-check-dialog-presenter-base";
import {IShowRealityCheckOptions} from "../reality-check-presenter.interface";
import {
    TSR_TYPE
} from "../../../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/time-spent-reminder-options";


export class UkRealityCheckPresenter extends RealityCheckDialogPresenterBase {
    protected async _showDialog(options: IShowRealityCheckOptions, onDialogClosed: () => void): Promise<IModalDialogHandler> {
        return this.services.specificDialogs.showTimeSpentReminderWithDropdown({
            timerType: TSR_TYPE.SESSION_TIMER,
            realityCheckAnalytics: options.analytics,
            onDialogClosed: onDialogClosed
        });
    }

}